import React from 'react';
import { Table, Button, Row, Col, Popconfirm, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

export default function InvoiceConfigList({ settings, onEdit, onAdd, loading }) {
  const columns = [
    { title: 'Name', dataIndex: 'description', key: 'description' },
    { title: 'Key', dataIndex: 'name', key: 'name' },
    { title: 'Value', dataIndex: 'value', key: 'value' },
    {
      title: 'Actions', key: 'actions',
      render: (_, record) => (
        <Space gap="small" wrap>
          <Button onClick={() => onEdit(record)}>Edit</Button>
        </Space>
      )
    }
  ];

  return (
    <>
      <Row justify="end">
        <Col>
          <Button type="primary" onClick={onAdd} icon={<PlusOutlined />} className='mb-16'>
            ADD
          </Button>
        </Col>
      </Row>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={settings}
        loading={loading}
        size="small"
        scroll={{ x: 'max-content' }}
        pagination={false}
      />
    </>
  );
}
